import React from "react";
import tw from "twin.macro";
import { Helmet } from "react-helmet-async";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";

import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
import Features from "components/features/ThreeColWithSideImage.js";
import HowAnonymityWorks from "components/features/HowAnonymityWorks.js";
import InsightsForLeadership from "components/features/InsightsForLeadership.js";
import PricingTeaser from "components/pricing/PricingTeaser.js";
import Blog from "components/blogs/GridWithFeaturedPost.js";
import FAQ from "components/faqs/SingleCol.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import Features7 from "components/features/OnboardingSteps.js";




const HighlightedText = tw.span`text-primary-500`

export default () => {
  return (
    <AnimationRevealPage>
      <Helmet>
        <title>EthosHub | Anonymous Workplace Reporting Platform</title>
        <meta name="description" content="EthosHub is a secure, anonymous workplace reporting platform for HR and employees. Report bullying, harassment, and discrimination while building a safer, compliant culture." />
        <link rel="canonical" href="https://www.ethoshub.io/" />
        <meta property="og:title" content="EthosHub | Anonymous Workplace Reporting Platform" />
        <meta property="og:description" content="Secure, anonymous incident reporting that helps organisations prevent bullying, harassment and discrimination — with the tools to act quickly and compliantly." />
        <meta property="og:url" content="https://www.ethoshub.io/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "EthosHub",
          "url": "https://www.ethoshub.io",
          "description": "Secure, anonymous workplace misconduct reporting platform for HR and employees. Covers bullying, harassment, discrimination and more.",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "offers": {
            "@type": "Offer",
            "priceCurrency": "GBP",
            "availability": "https://schema.org/InStock"
          },
          "publisher": {
            "@type": "Organization",
            "name": "EthosHub",
            "url": "https://www.ethoshub.io",
            "logo": "https://www.ethoshub.io/favicon.ico",
            "sameAs": []
          }
        })}</script>
      </Helmet>
      <Header />
      <Hero />
      {/* The stats band ("Over 9,000 Incidents Resolved", 12,500 users, 183
          caseworkers) was template placeholder data and has been removed.
          Reinstate it only with real, defensible figures. */}
      <HowAnonymityWorks />
      <Features
        heading={<>Built for HR. <HighlightedText>Designed for Trust.</HighlightedText></>}
      />
      <InsightsForLeadership />
      <Features7 />
      <PricingTeaser />
      <FAQ
        heading={<>Frequently Asked <HighlightedText>Questions</HighlightedText></>}
      />
      <Blog
        subheading="Blog"
        heading={<>Guidance for <HighlightedText>HR teams</HighlightedText></>}
      /> 
      {/*<Testimonial 
        heading={<>Our Clients <HighlightedText>Love Us</HighlightedText></>}
      />*/}
      <Footer />
    </AnimationRevealPage>
  );
}
